import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { isNil } from 'lodash-es';
import { Store, select } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { SeStepperSideComponentBase } from "../se-stepper-side-nav.models";
import { DetailItem } from "../../se-side/se-side-components/se-side-details/se-side-details-models";
import { SearchPageConfigurationService } from '../../search-page/search-page-configuration.service';
import { RootState } from '../../root-store/root.state';
import { SearchFormType } from '../../search-page/search-page-type.enum';
import { EstensaColDef } from '../../search-page/search-param.model';
import { selectSeSearchSelectedItems } from '../../search-page/redux/search-page.selectors';
import { GridUtilitiesService } from '../../services/grid-utilities.service';

@Component({
    selector: 'se-stepper-side-nav-details',
    templateUrl: './se-stepper-side-nav-details.component.html',
    styleUrls: ['./se-stepper-side-nav-details.component.scss'],
    standalone: false
})
export class SeStepperSideNavDetailsComponent extends SeStepperSideComponentBase implements OnInit, OnDestroy {

    private feedbackMessage : Map<number, string> = new Map<number, string>();
    private readonly unsubscribe$ : Subject<void> = new Subject();
    @Input() title? : string = '';

    colDefs: EstensaColDef[] = [];
    details : Array<DetailItem> = [];
    formType : SearchFormType; // = SearchFormType.DIRECT_ADMISSION;
    koMessage: string = '';
    showDetailsNote: boolean = true;

    constructor(
        readonly searchPageConfigurationService: SearchPageConfigurationService,
        readonly store: Store<RootState>,
        readonly gridUtils: GridUtilitiesService,
    ) {
        super();
        this.feedbackMessage.set(-1, 'NoDetail');
        this.feedbackMessage.set(0, 'NoSelection');
        this.feedbackMessage.set(1, '');
        this.feedbackMessage.set(2, 'MultipleSelection');
    }

    ngOnInit() {
        this.initComponent();
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    _isTooltipDisabled (element) {
        return element.offsetWidth >= element.scrollWidth;
    }

    private retrieveDetails (formType : SearchFormType, idPropertyName: string) {
        this.store
            .pipe(select(selectSeSearchSelectedItems(formType, idPropertyName)), takeUntil(this.unsubscribe$))
            .subscribe((response) => this.getDetails(response, this.gridUtils));
    }

    private initComponent() {
        this.store
            .select((state) => state.seStepperSideNav.summary)
            .subscribe((detailsConfig) => {
                this.initColDefs(detailsConfig.searchForm);
                this.retrieveDetails(detailsConfig.searchForm, detailsConfig.idColumnName);
            });
    }

    private initColDefs (formType : SearchFormType) {
        this.colDefs = this.searchPageConfigurationService.getAllColumnDefs(formType);
        if (!this.colDefsFound()) {
            console.error('No ColDefs found in page');
            return;
        }
        this.koMessage = !this.colDefs.length
            ? this.feedbackMessage.get(-1)
            : this.feedbackMessage.get(0);
    }

    private colDefsFound(): boolean {
        return !isNil(this.colDefs) && this.colDefs.length > 0;
    }

    private getDetails(data: any[], gridUtils: GridUtilitiesService) {
        this.details = [];
        if (data.length !== 1) {
            this.koMessage = this.feedbackMessage.get(data.length === 0 ? 0 : 2);
            return;
        }
        this.koMessage = this.feedbackMessage.get(1);
        this.colDefs.forEach((colDef : EstensaColDef) => {
            this.details.push(new DetailItem(colDef, data[0]));
        });
    }
}
